module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("\n        返回首页\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Single select")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.options,
      "searchable": false,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "Pick a value"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('pre', {
    staticClass: "language-json"
  }, [_c('code', [_vm._v(_vm._s(_vm.value))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cdad1112","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Cust/DiyGoods.vue
// module id = 1724
// module chunks = 8